/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

// Trainer mode menu items (flat, no groups)
// Note: titles are translation keys, use | translate in templates
export const trainerNavigation: FuseNavigationItem[] = [
    {
        id: 'profile',
        title: 'nav.profile',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/app/profile',
        exactMatch: true,
    },
    {
        id: 'requests',
        title: 'nav.requests',
        type: 'basic',
        icon: 'heroicons_outline:inbox',
        link: '/app/profile/requests',
    },
    {
        id: 'earnings',
        title: 'nav.earnings',
        type: 'basic',
        icon: 'heroicons_outline:cash',
        link: '/app/profile/earnings',
    },
];

// Gym mode menu items (flat, no groups)
// Note: titles are translation keys, use | translate in templates
export const gymNavigation: FuseNavigationItem[] = [
    {
        id: 'gym-dashboard',
        title: 'nav.dashboard',
        type: 'basic',
        icon: 'heroicons_outline:view-grid',
        link: '/app/gym',
    },
    {
        id: 'contacts',
        title: 'nav.trainers',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/app/contacts',
    },
    {
        id: 'gym-billing',
        title: 'nav.billing',
        type: 'basic',
        icon: 'heroicons_outline:currency-euro',
        link: '/app/gym/billing',
    },
    {
        id: 'gym-settings',
        title: 'nav.settings',
        type: 'basic',
        icon: 'heroicons_outline:cog',
        link: '/app/gym/settings',
    },
];

// Default shows trainer nav (mode will override)
export const defaultNavigation: FuseNavigationItem[] = trainerNavigation;
export const compactNavigation: FuseNavigationItem[] = trainerNavigation;
export const futuristicNavigation: FuseNavigationItem[] = trainerNavigation;
export const horizontalNavigation: FuseNavigationItem[] = trainerNavigation;
